export { default as component } from "../../../../src/routes/(registration)/auth/login/+page.svelte";